
    <mat-card  style="display: flex;align-items: center;" >
      <div class="flex-justify w-100" style="background-color: var(--primary-color); color: var(--accent-color);padding: 5px;">
        <span mat-card-title>{{data.title}}</span>
        <mat-icon style="color:white !important;padding-top: 2px;">{{data.titleIcon}}</mat-icon>
      </div>
      <mat-card-content appearance="outlined" class="pt-1 pb-1">
        <div class="message-container">{{ data.message }}</div>
      </mat-card-content>
      <mat-card-content class="flex-justify">
        <button mat-button (click)="confirm()" style="color: var(--primary-color); background-color: white;">{{ data.confirmText }}</button>
        <button mat-button style="color: red;" (click)="closeDialog()">{{ data.cancelText }}</button>
      </mat-card-content>
    </mat-card> 



<!--  -->
